import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import "./meetings.css";

const MeetingsPage = lazy(() => import("./list").then((m) => ({ default: m.MeetingsPage })));
const MeetingPage = lazy(() => import("./meeting").then((m) => ({ default: m.MeetingPage })));
const NewMeetingPage = lazy(() => import("./meeting").then((m) => ({ default: m.NewMeetingPage })));
const MeetingTodosPage = lazy(() => import("./todos").then((m) => ({ default: m.MeetingTodosPage })));
const MeetingVoicesPage = lazy(() => import("./voices").then((m) => ({ default: m.MeetingVoicesPage })));

/** Meetings: the list, one meeting (and a new one), every to-do, and Who's who. No settings of its own. */

export const routes: SolutionRoute[] = [
  { solution: "meetings", path: "meetings", element: <MeetingsPage /> },
  { solution: "meetings", path: "meetings/new", element: <NewMeetingPage /> },
  { solution: "meetings", path: "meetings/todos", element: <MeetingTodosPage /> },
  { solution: "meetings", path: "meetings/voices", element: <MeetingVoicesPage /> },
  { solution: "meetings", path: "meetings/:id", element: <MeetingPage /> },
];

export const settings: SolutionSettings[] = [];
